module.exports = __webpack_public_path__ + "956e379232cf0959172db3d80244c5d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/9.jpg
// module id = ./src/components/Carousel/images/9.jpg
// module chunks = 0